import { apiCall } from '../../utils';

export const getProvinces = params =>
  apiCall({
    url: '/locations/provinces/',
    method: 'get',
    params,
  });

export const getCities = params =>
  apiCall({
    url: '/locations/cities/',
    method: 'get',
    params,
  });

export const resolveCitySlug = citySlug =>
  apiCall({
    url: '/locations/cities/resolve/',
    method: 'get',
    params: { slug: citySlug },
  });

export const getNearestCity = () =>
  apiCall({
    url: '/locations/cities/nearest/',
    method: 'get',
  });